module.exports = exports = require('./lib/sliced');



//////////////////
// WEBPACK FOOTER
// ../~/virtual-element/~/sliced/index.js
// module id = 3061
// module chunks = 0